import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=0c5ae738&scoped=true"
import script from "./Galeria.vue?vue&type=script&lang=ts"
export * from "./Galeria.vue?vue&type=script&lang=ts"
import style0 from "./Galeria.vue?vue&type=style&index=0&id=0c5ae738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ae738",
  null
  
)

export default component.exports